import { createFileRoute, Outlet } from '@tanstack/react-router';
import { MessageSquareWarning } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/complaints')({
    staticData: {
        breadcrumb: {
            title: 'Complaints',
            inactive: true,
        },
        modules: ['compliance'],
        permissions: ['settings:update'],
        ui: {
            icon: MessageSquareWarning,
            title: 'Complaints',
            useTitleForChildren: true,
            menuDescription: 'Settings, rules, brands, custom fields and flags',
        },
    },
    component: Outlet,
});
